import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";

const NewsCard = ({ news }) => {
  const navigate = useNavigate();



  return (
    <div
      onClick={() => navigate(`/blogDetails/${news._id}`)}
      className="group cursor-pointer overflow-hidden rounded-3xl bg-white border border-gray-200 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
    >
      {/* Image */}
      <div className="relative overflow-hidden">
        <img
          src={news.cardImage}
          alt={news.title}
          className="w-full h-64 object-cover transition-transform duration-700"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-500"></div>
      </div>

      {/* Content */}
      <div className="p-4">

        <h2 className="text-2xl font-bold text-[#1B212A] leading-snug line-clamp-2 group-hover:text-[#E94907] transition-colors">
          {news.title}
        </h2>

        {/* Orange Line */}
        <div className="mt-4 h-1 w-16 rounded-full bg-[#E94907] group-hover:w-24 transition-all duration-300"></div>

        <p className="mt-3 text-gray-600 leading-7 line-clamp-3">
          {news.shortDescription}
        </p>

        {/* Button */}
        <div className="mt-3 flex items-center text-[#E94907] font-semibold text-lg group">
          <span>Read Article</span>

          <ArrowRight
            size={20}
            className="ml-2 transition-transform duration-300 group-hover:translate-x-2"
          />
        </div>
      </div>
    </div>
  );
};

export default NewsCard;